<!-- PROCESO NORMAL -->
<tec-pwcs-layout
    [ngClass]="{'pwcs-style-old': operation.config?.iframe, 'dark': designService.isDarkMode()}"
    [title]="pageWarning.type === PAGE_WARNING.HELP ? ('LIFE_CHECK.HELP.TITLE' | translate) : ''"
    [subtitle]="getSubtitle()"
    [footerLabel]="operation?.config.tutorial && !pageWarning.show && permissionsCamera ? ('GENERAL.TUTORIAL_ENCRYPTION' | translate) : ''">
    @if (testMode && !env.production) {
        <tec-topnav [img]="'assets/images/tecalis' + (designService.isDarkMode() ? '-dark' : '') + '.svg'">
            <!-- <tec-switch size="sm" label="Dark mode" [formControl]="darkMode"></tec-switch> -->
            <tec-switch size="sm" label="Rect" [formControl]="formRect" (valueChange)="positionDocumentService.setDraw($event)"></tec-switch>
            <tec-switch size="sm" label="Stats" [formControl]="formStats"></tec-switch>
            @if (formStats.value) {
                <div class="stats">
                    <span>Min sharpness: {{ controls.minSharpness }} => {{ controls.sharpness }}</span>
                    <span>Brightness: {{ (controls.brightness | number: '1.0-2') || 0 }}%</span>
                    <span>Time total ocr: {{ totalTime }} seg</span>
                </div>
            }
        </tec-topnav>
    }

    <ng-container content>
        <!-- SIN PERMISOS -->
        @if (!permissionsCamera) { 
        <tec-tile
            type="status"
            [title]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_TITLE' | translate"
            [subtitle]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_DESCRIPTION' | translate"
            icon="icon-alert">
            <tec-link [label]="'LIFE_CHECK.HELP.TITLE' | translate" (click)="isVisibleHelpNoPermissionsCamera = true;"></tec-link>
        </tec-tile>
        }

        <!-- CON PERMISOS -->
        @if (permissionsCamera) {
            <!-- MAIN -->
            <div class="content__identity" [ngStyle]="{'display': operation?.config.tutorial || pageWarning.show ? 'none' : 'contents'}">
                @if (loading.show) {
                <tec-spinner
                    [show]="loading.show"
                    [opaque]="true"
                    [text]="loading.text"
                    [img]="designService.getCustomSpinnerUrl() || undefined"
                ></tec-spinner>
                }
                <tec-scan
                    [hidden]="loading.show"
                    [match]="match">
                    <div>
                        <video id="video"
                            autoplay
                            playsinline
                        ></video>
                        <canvas id="controlCanvas"
                            [ngClass]="{'output_canvas': formRect?.value}"
                            [ngStyle]="{'display': formRect?.value ? '' : 'none'}"
                        ></canvas>
                    </div>
                </tec-scan>
                <div class="tec-alert--float">
                    @if (!loading.show && getContentAlert().label && getContentAlert().status) {
                    <tec-alert
                        hiddenCloseButton
                        type="message"
                        [status]="getContentAlert().status"
                        [msg]="getContentAlert().label"
                        [icon]="getContentAlert().icon"
                    ></tec-alert>
                    }
                </div>

                <!-- BOTON CAMBIO CAMARA -->
                @if (operation?.config?.iframe && allCameras && allCameras.length > 1) {
                    <div class="change-camera">
                        <span>{{ 'GENERAL.BUTTON.CHANGE_CAMERA' | translate }}</span>
                        <tec-button-icon
                            icon="icon-refresh"
                            type="circle"
                            size="lg"
                            (clickEvent)="changeCamera()"
                        ></tec-button-icon>
                    </div>
                }

                <!-- QR -->
                @if (operation?.config?.iframe && !loading.show) {
                    <div [ngClass]="{'widget': true, 'open': openQR}" >
                        <div class="widget__intro">
                            <h6>{{ 'GENERAL.QR.TITLE' | translate }}</h6>
                            <span>{{ 'GENERAL.QR.DESCRIPTION' | translate }}</span>
                        </div>
                        <div class="widget__content">
                            <div class="widget__content__qr" id="qrcode2" [title]="auth.getQRUrl()">
                                <tec-qr [url]="auth.getQRUrl()" />
                            </div>
                            <p class="widget__content__url">{{ auth.getQRUrl() }}</p>
                        </div>
                        <button class="button button-icon" (click)="openQR = !openQR">
                            <i class="icon-chevron-down"></i>
                        </button>
                    </div>
                }

                <!-- Imágenes auxiliares -->
                <div style="display: none;">
                    <img id="imageAux1">
                    <img id="imageAux2">
                    <canvas id="canvasAux1"></canvas>
                    <canvas id="canvasAux2"></canvas>
                </div>
            </div>

            <!-- TUTORIAL -->
            @if (operation?.config.tutorial && !pageWarning.show) {
                <div class="tutorial-image">
                    @if (operation.type === operationType.OCR_CANNY) {
                        <pwcs-inline-svg
                            [src]="'assets/images/doc-reverse' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                            idSuffix="ocr-canny-tutorial-doc"
                        />
                    }
                </div>
            }

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    <div class="tile tile--help">
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-blurred' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="ocr-canny-help-id-blurred"
                            />
                            <p>
                                <tec-icon name="icon-x-circle"></tec-icon>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_1' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-bright' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="ocr-canny-help-id-bright"
                            />
                            <p>
                                <tec-icon name="icon-x-circle"></tec-icon>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_2' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-cut' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="ocr-canny-help-id-cut"
                            />
                            <p>
                                <tec-icon name="icon-x-circle"></tec-icon>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_3' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-finger' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="ocr-canny-help-id-finger"
                            />
                            <p>
                                <tec-icon name="icon-x-circle"></tec-icon>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_6' | translate }}</span>
                            </p>
                        </div>
                    </div>
                    <tec-alert [msg]="'OCR.BACK.MODAL_HELP.TIP_5' | translate" type="message" hiddenCloseButton icon="icon-info"></tec-alert>
                }
                @if (pageWarning.type === PAGE_WARNING.NO_FACE) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.NO_FACE.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.NO_FACE.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.MULTIPLE_FACES) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.MULTIPLE_FACES.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.MULTIPLE_FACES.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.VERIFICATION_FAIL) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.CAMERA_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.DESCRIPTION' | translate"
                        icon="icon-alert">
                    </tec-tile>
                }
            }
    }
    </ng-container>

    <!-- ACCIONES -->
    <ng-container actions>
        <!-- SIN PERMISOS -->
        @if (!permissionsCamera) {
            <tec-button type="secondary" (clickEvent)="isVisibleChangeDevice = true;">
                {{ 'GENERAL.BUTTON.OTHER_DEVICE' | translate }}
            </tec-button>
            <tec-button (clickEvent)="checkPermissions()">
                {{ 'GENERAL.BUTTON.PERMISSIONS_ACTIVATED' | translate }}
            </tec-button>
        }

        <!-- CON PERMISOS -->
        @if (permissionsCamera) {
            <!-- TUTORIAL -->
            @if (operation?.config.tutorial && !pageWarning.show) {
                <tec-button
                    [label]="'GENERAL.BUTTON.IM_READY' | translate"
                    [type]="'default'"
                    [size]="'lg'"
                    (clickEvent)="finishTutorial()"
                ></tec-button>
            }

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'secondary'"
                        (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.HELP)"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                        [type]="'default'"
                        (clickEvent)="isVisibleChangeDevice = true"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.NO_FACE) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.RESET_POL' | translate"
                        [type]="'default'"
                        (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.NO_FACE)"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.MULTIPLE_FACES) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.RESET_POL' | translate"
                        [type]="'default'"
                        (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.MULTIPLE_FACES)"
                    ></tec-button>
                }
            }
        }
    </ng-container>

    <!-- NAV HELP -->
    @if (!operation?.config?.iframe && permissionsCamera && !pageWarning.show) {
        <tec-nav-help
            [elements]="operation?.config?.tutorial ? navsHelpTutorial : navsHelp"
            (clickEvent)="navHelpChange($event)"
        ></tec-nav-help>
    }

    <!-- WATERMARK -->
    @if ((designService.configDesign$ | async)?.showWatermark && !operation?.config?.iframe) {
        <tec-watermark type="default" />
    }
</tec-pwcs-layout>

<app-modal-scan-qr
    [ngClass]="{'pwcs-style-old': operation.config?.iframe, 'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
></app-modal-scan-qr>

<app-modal-help-document
    [ngClass]="{'pwcs-style-old': operation.config?.iframe, 'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleHelp"
    [url]="auth.getQRUrl()"
    [operation]="operation"
></app-modal-help-document>

<app-modal-help-no-camera-permissions
    [ngClass]="{'pwcs-style-old': operation.config?.iframe, 'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleHelpNoPermissionsCamera"
    [url]="auth.getQRUrl()"
></app-modal-help-no-camera-permissions>

<app-modal-change-device
    [ngClass]="{'pwcs-style-old': operation.config?.iframe, 'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleChangeDevice"
    [url]="auth.getQRUrl()"
></app-modal-change-device>

